import {
  TAKEAWAY_FIELD_PHONE,
  TAKEAWAY_FIELD_FIO,
  TAKEAWAY_FIELD_EMAIL,
} from 'store/common/form/constants';
import {
  composePhoneValidator,
  composeNameValidator,
  composeEmailValidator,
  composeRequiredValidator,
} from 'utils/fieldValidators';

export const getValidators = () => ({
  [TAKEAWAY_FIELD_PHONE]: [
    composeRequiredValidator('Не указан телефон'),
    composePhoneValidator('Неверный номер телефона'),
  ],
  [TAKEAWAY_FIELD_FIO]: [
    composeRequiredValidator('Обязательное поле'),
    composeNameValidator('Неверный формат имени'),
  ],
  [TAKEAWAY_FIELD_EMAIL]: [composeEmailValidator('Неверный формат email')],
});

/**
 * iterate fields that have validators and each validator individually
 * gather field errors in a large object return it
 */
export const getValidationErrors = (values, props) => {
  const validators = getValidators();
  return Object.keys(validators).reduce((errors, name) => {
    validators[name].some((fieldValidator) => {
      const fieldError = fieldValidator(values[name], values, props);
      if (fieldError) {
        errors[name] = fieldError;
        return true;
      }
      return false;
    });
    return errors;
  }, {});
};

export const convertNameForGTM = (name) => {
  const dict = {
    phone: 'Контактный телефон',
    name: 'Имя',
    email: 'Email',
  };
  return dict[name];
};

export const toggleBodyStyleForAndroid = (action) => {
  if (/Android/.test(navigator.appVersion)) {
    document.body.style.position = action === 'mount' ? 'fixed' : 'static';
  }
};
